import { Paper, Tab, Tabs, withStyles } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import * as EVENTS from '../App/Constants/Events';
import * as TELEMETRY from '../App/Constants/Telemetry';
import * as TRANSITION from '../App/Constants/Transition'
import DocumentStore from '../App/Stores/DocumentStore';
import DocumentListItem from '../App/Models/DocumentListItem';
import PictureAsPdf  from '@material-ui/icons/PictureAsPdf';

const styles = (theme: any) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: 500,
  }
});

interface Props {
  documentStore: DocumentStore;
  document: DocumentListItem
}

class DocumentDownloader extends React.Component<Props> {

  private timeout: any;

  constructor(props: Props) {
    super(props);
    this.state = {
      value: 0,
      isDisplayLoadingAnimation: false
    };
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(doc: any): void {
    const { documentStore } = this.props;
    if (!documentStore || !doc.id) return;
    window.telemetry.logEvent(TELEMETRY.EVENTS.DOWNLOAD_RESOURCE_DOCUMENT);
    documentStore.getNZFAPDocument(doc.id).then(async result => {
      const data = result && result.data;
      if (!data) return;
      const url = URL.createObjectURL(data);
      console.log(document)
      var save = document.createElement('a');
      save.href = url;
      save.target = '_blank';
      save.download = doc.name || 'unknown';
      save.click()
      window.URL.revokeObjectURL(url);
    });
  }

  cleanupName(name: string){
    let result = name.replaceAll('_', ' ');
    result = result.replace('.pdf', '');
    if(result.length > 70){
      result = result.substring(0, 67).concat('...');
    }

    return result
  }

  render() {
    const {  documentStore, document } = this.props;
    return (
      <div className="c-documents__list-document-download">
        <div className='c-documents__list-document-download-flex-container'>
          <div className='c-documents__list-document-download-icon-container'><PictureAsPdf className='c-documents__list-document-download-icon'></PictureAsPdf></div>
          <div className='c-documents__list-document-download-name-container'>{this.cleanupName(document.name)}</div>
        </div>
        <div className='c-documents__list-document-download-button-container' onClick={() => document && this.handleClick(document)}><div className='c-documents__list-document-download-button'>DOWNLOAD</div></div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(DocumentDownloader);